import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import _ from "lodash";
import React from "react";
import { t } from "ttag";
import Button from "../../cool_widgets/Button";
import { Close } from "../../icons";
import useStyles from "./ErrorBox.style";

export default function ErrorBox(props: any) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    props.onClose();
    setOpen(false);
  };

  const classes = useStyles();
  const missingFields = _.isArray(props.error)
    ? <ul className={classes.content}>{_.map(props.error, (error, index) => <li key={index}>{error}</li>)}</ul>
    : props.error;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      aria-describedby="form-dialog-description"
      classes={{ paper: classes.dialogStyle }}
    >
      <div className={classes.titleContainer}>
        <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
        <IconButton disableRipple onClick={handleClose} className={classes.overWriteIcon}>
          <Close color="#7f7692" />
        </IconButton>
      </div>
      <DialogContent className={classes.view}>
        <Typography>{missingFields}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} width={130} style={{ marginRight: "20px" }} white>
          {props.cancelBtnTitle || t`Cancel`}
        </Button>
        <Button onClick={props.onAccept} width={130}>
          {props.AcceptBtnTitle || t`Ok`}
        </Button>
      </DialogActions>
    </Dialog >
  );
}
